export const INIT_PROFILE = 'initProfile';
export const SET_PROFILE_TAB = 'setProfileTab';
export const SET_PROFILE_LIKE = {
  COLLECTIONS: 'setProfileCollectionsLike',
  JOURNALS: 'setProfileJournalsLike',
  TRIPS: 'setProfileTripsLike',
  PRODUCTS: 'setProfileProductLike'
};
export const GET_PROFILE_MEMBERS = {
  INIT: 'getProfileMembersInit',
  LOADING: 'getProfileMembersLoading',
  SUCCESS: 'getProfileMemberSuccess',
  FAIL: 'getProfileMembersFail',
  NEXT_LOADING: 'getProfileMembersNextLoading',
  NEXT_SUCCESS: 'getProfileMembersNextSuccess',
  NEXT_FAIL: 'getProfileMembersNextFail'
};
export const GET_PHOTOS = {
  LOADING: 'getPhotosLoading',
  SUCCESS: 'getPhotosSuccess',
  FAIL: 'getPhotosFail',
  NEXT: 'getPhotosNext'
};
export const GET_PORFILE = {
  LOADING: 'getProfileLoading',
  SUCCESS: 'getProfileSuccess',
  FAIL: 'getProfileFail'
};
export const GET_ACCOUNT_LIST = {
  LOADING: 'getAccountListLoading',
  SUCCESS: 'getAccountListSuccess',
  FAIL: 'getAccountListFail'
};
export const SET_SWITCH_ACCOUNT = {
  LOADING: 'setSwitchAccountLoading',
  SUCCESS: 'setSwitchAccountSuccess',
  FAIL: 'setSwitchAccountFail'
};
export const GET_PUBLIC_LIKED = {
  LOADING: 'getPublicLikedLoading',
  SUCCESS: 'getPublicLikedSuccess',
  FAIL: 'getPublicLikedFail',
  NEXT: 'getPublicLikedNext'
};
export const GET_PUBLIC_TRIPS = {
  LOADING: 'getPublicTripsLoading',
  SUCCESS: 'getPublicTripsSuccess',
  FAIL: 'getPublicTripsFail',
  NEXT: 'getPublicTripsNext'
};
export const GET_PUBLIC_PUBLISHED = {
  LOADING: 'getPublicPublishedLoading',
  SUCCESS: 'getPublicPublishedSuccess',
  FAIL: 'getPublicPublishedFail',
  NEXT: 'getPublicPublishedNext'
};
export const GET_PUBLIC_COLLECTIONS_LIST = {
  LOADING: 'getPublicCollectionsListLoading',
  SUCCESS: 'getPublicCollectionsListSuccess',
  FAIL: 'getPublicCollectionsListFail',
  NEXT: 'getPublicCollectionsListNext'
};

export const GET_PROFILE_PRODUCT_LIST = {
  LOADING: 'getProfileProductListLoading',
  SUCCESS: 'getProfileProductListSuccess',
  FAIL: 'getProfileProductListFail',
  NEXT: 'getProfileProductListNext'
};
export const GET_PROFILE_FANS = {
  LOADING: 'getProfileFansLoading',
  SUCCESS: 'getProfileFansSuccess',
  FAIL: 'getProfileFansFail',
  NEXT_LOADING: 'getProfileFansNextLoading',
  NEXT_SUCCESS: 'getProfileFansNextSuccess',
  NEXT_FAIL: 'getProfileFansNextFail'
};

export const GET_PROFILE_FOLLOWINGS = {
  LOADING: 'getProfileFollowingsLoading',
  SUCCESS: 'getProfileFollowingsSuccess',
  FAIL: 'getProfileFollowingsFail',
  NEXT_LOADING: 'getProfileFollowingsNextLoading',
  NEXT_SUCCESS: 'getProfileFollowingsNextSuccess',
  NEXT_FAIL: 'getProfileFollowingsNextFail'
};

export const SET_CURRENT_PROFILE_FOLLOWINGS = {
  LOADING: 'setCurrentProfileFollowingsLoading',
  SUCCESS: 'setCurrentProfileFollowingsSuccess',
  FAIL: 'setCurrentProfileFollowingsFail'
};

export const GET_RECOMMEND_FOLLOWINGS = {
  LOADING: 'getRecommendFollowingsLoading',
  SUCCESS: 'getRecommendFollowingsSuccess',
  FAIL: 'getRecommendFollowingsFail',
  NEXT_LOADING: 'getRecommendFollowingsNextLoading',
  NEXT_SUCCESS: 'getRecommendFollowingsNextSuccess',
  NEXT_FAIL: 'getRecommendFollowingsNextFail'
};

export const UPLOAD_AVATAR = {
  LOADING: 'uploadAvatarLoading',
  SUCCESS: 'uploadAvatarSuccess',
  FAIL: 'uploadAvatarFail'
};

export const UPLOAD_AVATAR_TO_S3 = {
  LOADING: 'uploadAvatarToS3Loading',
  SUCCESS: 'uploadAvatarToS3Success',
  FAIL: 'uploadAvatarToS3Fail'
};

export const RESET_UPLOAD_AVATAR_STATUS = 'RESET_UPLOAD_AVATAR_STATUS';

export const UPLOAD_PROFILE_COVER = {
  LOADING: 'uploadProfileCoverLoading',
  SUCCESS: 'uploadProfileCoverSuccess',
  FAIL: 'uploadProfileCoverFail'
};

export const UPLOAD_PROFILE_COVER_TO_S3 = {
  LOADING: 'uploadProfileCoverToS3Loading',
  SUCCESS: 'uploadProfileCoverToS3Success',
  FAIL: 'uploadProfileCoverToS3Fail'
};

export const RESET_UPLOAD_PROFILE_COVER_STATUS =
  'RESET_UPLOAD_PROFILE_COVER_STATUS';

export const CHANGE_NICKNAME = {
  LOADING: 'changeNickNameLoading',
  SUCCESS: 'changeNickNameSuccess',
  FAIL: 'changeNickNameFail'
};
